module.exports = __webpack_public_path__ + "src/img/imgIcon.65cbb1e2.svg";